/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { callApi } from 'src/utils/apiCall';

import { setOpenCallScriptFromLeadPage } from 'src/redux/slices/callScript';
import { markAsSpam as markLeadAsSpam } from 'src/redux/slices/spamLeads';

// libraries
import { Box, Stack, Card, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Grid, Button, AppBar, Typography, Tabs, Tab, Grow, Popper, Paper, ClickAwayListener, MenuList, MenuItem, IconButton, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import { isArray, isEmpty } from 'lodash';
import moment from 'moment';
import useSnackbar from 'src/hooks/useCustomSnackbar';
import { AccountSocialLinks } from 'src/sections/@dashboard/user/account';
import OverviewTab from 'src/sections/@dashboard/lead/OverviewTab';
import AttendedChecklistV2, { useAttendedChecklistVisibility } from 'src/sections/@dashboard/leadDetail/AttendedChecklistV2';

import { updateLeadDataCount } from 'src/redux/slices/whatsapp';
import { updateError } from 'src/redux/slices/user';
import { clearRound } from 'src/redux/slices/contactRound';
import capitalizeFirstLetter from '../../utils/capitalizedFunc';
import { normalizePracticeId, resolveContactPracticeId } from '../../utils/contactPracticeContext';
// components
import Iconify from '../Iconify';
import StartTreatmentPopup from '../dialogPopUp/StartTreatmentPopup';
import SimilarLeadWarningPopup from '../../sections/@dashboard/leadDetail/SimilarLeadWarningPopup';
import { RenderActiveStep, Transition } from '../dialogPopUp';
import CustomCompleteTreatmentDialog from '../../pages/dashboard/tables/AllLeadTable/CustomCompleteTreatmentDialog';
import ButtonContainer from './ButtonContainer';
import ContactPopupDebugBox from './ContactPopupDebugBox';
// store
import { useSelector, dispatch } from '../../redux/store';
import {
    selectCreateLead,
    selectIsAppointmentBooked,
    selectArchivedLead,
    selectLeadFlowReminder,
    selectTaskFlowCounter,
    selectTableRowLead,
    selectNewLeadDetail,
    selectLeadNotes,
    selectLeadNotesArr,
    selectFollowLead,
    selectFollowLeadNotFound,
    selectAttendance,
} from '../../redux/selectors/leadSelectors';
import { updateSteps, updateBookingSteps, contactLeadSlice, updateActiveStep, updateFollowUpLead, setAttendedActiveTab, setCurrentTreatmentData, setDepositStatus, setTodoListFilter, leadTaskListCounter, UpdateDepositPendingStatus, setTreatmentLoading, setAction, leadFlowReminderData, getLeadNotes, getLeadReminderData, startLoadingData, updateCompleteStatus } from '../../redux/slices/lead';
import { setLoader } from '../../redux/slices/loader';
import { updateShowSubjectList } from '../../redux/slices/practiceMessage';
import { getPracticeId } from '../../redux/slices/clincheck';
// hooks
import { useResponsive, useToggle } from '../../hooks';
// style
import { menuListStyle } from '../../styles/NewLeadTableRowStyle';
import { contactLeadDialogStyle, contactLeadTitleStyle, listHeaderBoxStyle, popupMainStackStyle, contactLeadCancelButtonStyle, commonDialogHeaderStyle, activeStepTitleStyle, activeStepTextStyle, cancelBoxStyle, rightBoxInnerStyle, leftBoxInnerStyle, timeLineTypoV2, offerContentStyle, offerMainBoxStyle, offerBoxStyle, tabContentBoxStyle, tabsMainBoxStyle, tabButtonStyle, listCounterBoxStyle, footerButtonBoxStyle, cardMainAreaWrapper } from '../../styles/ContactLeadPopup';
import { menuItemStyle } from '../../styles/DialoguePopup';
import { NormalLoading } from '../loading';
import FollowUpWhatsappChat from '../whatsappComponents/FollowUpWhatsappChat';
import { formatUkPhone } from '../../utils/ukPhone';


// Follow-up contact stages for header stepper
const JOURNEY_STAGES = [
    { value: 'FOLLOW_UP_1', label: 'Follow up 1', step: 1 },
    { value: 'FOLLOW_UP_2', label: 'Follow up 2', step: 2 },
    { value: 'FOLLOW_UP_3', label: 'Follow up 3+', step: 3 },
];

const getFollowUpIndex = (contactedCount) => {
    if (contactedCount >= 3) return 2;
    if (contactedCount >= 1) return contactedCount - 1;
    return 0;
};

const OpenContactLeadPopup = ({ navigationLocked = false, navigationGuard, recoveryContent, handleReloadLeads, open, openArchivePopup, onClose, steps = [], type = 'lead', inputRef, user, updateStep = () => {}, validStep, headerButtons, onboaradHeaderButtons, setActive, BookingAttendance, ContactedCount, setOpenContactFromCall, embed = false, onBackEmbed, defaultTab = 'overview', bookingOnly = false, source = 'dashboard', threadId = null, onWhatsAppClose = null, debugSource = 'unknown', hideDebug = false, practiceId: contextPracticeId }) => {
    const [activeStep, setActiveStep] = useState(0);
    const isMobilePopup = useMediaQuery('(max-width:768px)');
    const [showMobileInfo, setShowMobileInfo] = useState(false);
    const { practiceId: reduxPracticeId } = useSelector((state) => state.practiceTreatmentList);
    const fallbackPracticeId = contextPracticeId === undefined
        ? reduxPracticeId
        : contextPracticeId;
    const practiceId = resolveContactPracticeId({
        lead: user,
        practiceId: normalizePracticeId(fallbackPracticeId),
    });
    const { hasleadDataUpdated } = useSelector(state => state?.whatsApp);
    const [outcome, setOutcome] = useState('Contact Lead');
    const { activeTab } = useSelector(state => state.singlePractice);
    const { isLoader } = useSelector((state) => state.loaderReducer);
    const { practice } = useSelector(state => state.practice);
    const createLead = useSelector(selectCreateLead);
    const isAppointmentBooked = useSelector(selectIsAppointmentBooked);
    const archivedLead = useSelector(selectArchivedLead);
    const leadFlowReminder = useSelector(selectLeadFlowReminder);
    const taskFlowCounter = useSelector(selectTaskFlowCounter);
    const tableRowLead = useSelector(selectTableRowLead);
    const newLeadDetail = useSelector(selectNewLeadDetail);
    const leadNotes = useSelector(selectLeadNotes);
    const leadNotesArr = useSelector(selectLeadNotesArr);
    const followLead = useSelector(selectFollowLead);
    const followLeadNotFound = useSelector(selectFollowLeadNotFound);
    const attendance = useSelector(selectAttendance);
    const isDentallyBooking = useSelector((state) => state.lead?.isDentallyBooking);
    const dentallyPatientId = useSelector((state) => state.lead?.dentallyPatientId);
    const [value, setValue] = useState(defaultTab);
    const [expandLayout, setExpandLayout] = useState(false);
    const isDesktop = useResponsive('down', 'sm');
    const [depositPaidStatus, setDepositPaidStatus] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [leadUserData, setLeadUserData] = useState([])
    const [NotesLength, setNotesLength] = useState([]);
    const [treatmentData, setTreatmentData] = useState(null);

    const { toggle: isOpenNextAction, onOpen: onOpenNextAction, onClose: onCloseNextAction } = useToggle();
    const { toggle: isOpenStartTreatment, onOpen: onOpenStartTreatment, onClose: onCloseStartTreatment } = useToggle();
    const [spamConfirmOpen, setSpamConfirmOpen] = useState(false);
    const anchorMoreMenuRef = useRef(null);

    const handleMarkAsSpam = () => {
        onCloseNextAction();
        setSpamConfirmOpen(true);
    };

    const handleMarkAsSpamConfirm = () => {
        setSpamConfirmOpen(false);
        const leadId = user?.lead_id || user?.id;
        dispatch(markLeadAsSpam({
            practiceId,
            leadId,
            handleClose: (status) => {
                if (status === 'finish' && handleReloadLeads) {
                    handleReloadLeads();
                }
                onClose();
            },
        }));
    };

    const { currentTreatmentDataGlobal } = useSelector((state) => state.multiTreatment);

    const isPaymentMandatory = practice?.preferences?.is_payment_enforced_before_treatment;

    const handleChange = (event, newValue) => setValue(newValue);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        dispatch(setLoader(false));
        dispatch(startLoadingData(false));
        dispatch(updateCompleteStatus(false));
    }, []);

    useEffect(() => {
        const currentLeadId = user?.lead_id || user?.id;
        if (!practiceId || !currentLeadId) return;
        // Clear local notes to avoid showing previous lead's info while loading
        setNotesLength([]);
        dispatch(updateLeadDataCount(false));
        dispatch(getLeadNotes(currentLeadId, practiceId, handleSuccess));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, 'leadNotes', currentLeadId, '', '', '', 'counter', '', false, true));
    }, [user?.id, user?.lead_id, practiceId]);

    const handleSuccess = (data) => {
        if (!data.success && data.message?.includes('Not found')) {
            enqueueSnackbar('This lead is no longer available', {
                variant: 'warning',
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
            }, true);
            return;
        }
        enqueueSnackbar(data.message || '', {
            variant: data.success ? 'success' : 'error',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
        });
    };

    useEffect(() => {
        const combineNotes = [];
        if (leadNotes && leadNotes.length > 0) {
            combineNotes.push(...leadNotes.filter((el) => el.additional_notes !== ''));
        }
        if (leadNotesArr && leadNotesArr?.results?.length > 0) {
            combineNotes.push(...leadNotesArr.results.filter((el) => el.note !== ''));
        }
        // if (leadFlowReminder?.results && leadFlowReminder?.results?.length > 0) {
        //     combineNotes.push(...leadFlowReminder?.results.filter((el) => el.note !== ''));
        // }

        if (combineNotes) {
            setNotesLength(
                combineNotes.sort(
                    (a, b) =>
                        new Date(moment(a.updated_at, 'DD-MM-YYYY HH:mm:ss')) -
                        new Date(moment(b.updated_at, 'DD-MM-YYYY HH:mm:ss'))
                )
            );
        }
    }, [user, leadNotes, leadNotesArr]);

    const treatmentShow = () => {
        if (treatmentData && treatmentData?.length > 0) {
            let treatmentToShow;
            if (!isEmpty(currentTreatmentDataGlobal?.treatmentData)) {
                treatmentToShow = treatmentData?.filter((el) => el.id === currentTreatmentDataGlobal?.treatmentData?.id);
                return treatmentToShow
            }

            return treatmentData?.filter((el) => el.id === tableRowLead?.treatment_id);
        }
        return [];
    }

    const [treatmentState, setTreatmentState] = React.useState(treatmentShow());

    React.useEffect(() => {
        setTreatmentState(treatmentShow());
    }, [treatmentData]);

    const TABS = [
        {
            icon: 'grommet-icons:overview',
            label: 'Overview',
            value: 'overview',
            component: <OverviewTab treatmentTabData={treatmentState} leadId={user?.lead_id || user?.id} setExpandLayout={setExpandLayout} handleChange={handleChange} expandLayout={expandLayout} leadReminder={leadFlowReminder} user={user} LeadNotes={NotesLength} showDetailModes />,
            width: 24,
            height: 24
        },
        {
            icon: 'ri:whatsapp-fill',
            label: 'Whatsapp',
            value: 'whatsapp',
            component: <Box sx={{
                height: '100%',
                background: 'white',
                borderRadius: '1rem',
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                '& > *': {
                    maxWidth: '100%',
                    flex: 1
                }
            }}>
                <FollowUpWhatsappChat user={user} followLead={followLead} />
            </Box>,
            width: 20,
            height: 20
        },
    ];


    const contactLeadId = user?.lead_id || user?.id;
    const contactLeadDetail = (followLead && Number(followLead.id) === Number(contactLeadId))
        ? followLead
        : { id: contactLeadId, lead_treatments: user?.lead_treatments || (user?.status ? [{ status: user.status }] : []) };
    const contactAttendedVisibility = useAttendedChecklistVisibility({
        practiceId,
        leadId: contactLeadId,
        leadDetail: contactLeadDetail,
    });
    if (contactAttendedVisibility.visible) {
        TABS.splice(2, 0, {
            icon: 'mdi:checkbox-marked-outline',
            label: 'Checklist',
            value: 'checklist',
            component: (
                <AttendedChecklistV2
                    practiceId={practiceId}
                    leadId={contactLeadId}
                    leadDetail={contactLeadDetail}
                />
            ),
            width: 20,
            height: 20,
        })
    }

    useEffect(() => {
        dispatch(setAttendedActiveTab(''));
        dispatch(setCurrentTreatmentData(null));
    }, []);

    // useEffect(() => {
    //     if (user) {
    //         dispatch(leadTaskListCounter(getPracticeId(), 'LeadDetail', 'NEW', user?.lead_id, '', '', undefined, true));
    //     }
    // }, [user]);

    useEffect(() => {
        const fetchData = async () => {
            const currentLeadId = user?.lead_id || user?.id;
            if (!practiceId || !currentLeadId) return;
            try {
                const respContextPractice = await callApi(
                    `/api/v1/practices/${practiceId}/leads/${currentLeadId}/treatments`,
                    'GET'
                );
                setLeadUserData(() => respContextPractice?.data?.results?.[0] ?? [])
                setTreatmentData(respContextPractice?.data?.results ?? [])
            } catch (error) {
                console.error('Error fetching context practice:', error);
            }
        };
        fetchData();
    }, [practiceId, dispatch, user?.id, user?.lead_id]);

    useEffect(() => {
        if (hasleadDataUpdated?.hasUpdated) {
            const fetchData = async () => {
                const currentLeadId = user?.lead_id || user?.id;
                if (!practiceId || !currentLeadId) return;
                try {
                    const respContextPractice = await callApi(
                        `/api/v1/practices/${practiceId}/leads/${currentLeadId}/treatments`,
                        'GET'
                    );
                    setLeadUserData(() => respContextPractice?.data?.results?.[0] ?? [])
                    setTreatmentData(respContextPractice?.data?.results ?? [])
                } catch (error) {
                    console.error('Error fetching context practice:', error);
                }
            };
            fetchData();
        }
    }, [hasleadDataUpdated, practiceId, user?.id, user?.lead_id])



    useEffect(() => {
        if (!open) {
            dispatch(clearRound());
        }
    }, [open]);

    useEffect(() => {
        if (validStep) {
            if (activeStep !== steps.length - 1) {
                dispatch(updateActiveStep(activeStep + 1));
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setTimeout(() => {
                    updateStep(false);
                }, 1000);
            } else if (!attendance || steps.length > 2) {
                // Close if: no pending step expansion OR steps already expanded (truly the last step)
                // When attendance is set but steps.length <= 2, the step array is about to expand
                updateStep(false);
                handleClose();
            }
            // attendance is set and steps haven't expanded yet — wait for steps.length to change
        }
    }, [validStep]);

    // Advance step when steps array grows (parent effect runs AFTER child effects in React,
    // so we must wait for steps.length to change rather than advancing on [BookingAttendance]).
    // Case 1: user pressed Next/Finish and attendance triggered step expansion.
    // Case 2: user clicked an outcome card → parent built steps[1]; advance race-free.
    useEffect(() => {
        if (validStep && activeStep < steps.length - 1) {
            dispatch(updateActiveStep(activeStep + 1));
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setTimeout(() => {
                updateStep(false);
            }, 1000);
        } else if (!validStep && BookingAttendance && steps.length > 1 && activeStep === 0) {
            // Race-safe: parent has already built steps[1], advance now
            dispatch(updateActiveStep(1));
            setActiveStep(1);
        }
    }, [steps.length]);

    // Only reset to step 0 when outcome is cleared; do NOT advance here —
    // the parent effect ([BookingAttendance,...]) builds steps[1] AFTER this
    // child effect fires, so advancing here causes a blank-panel race.
    useEffect(() => {
        if (!BookingAttendance) {
            setActiveStep(0);
        }
    }, [BookingAttendance]);

    useEffect(() => {
        if (setActive) setActive(activeStep);
    }, [activeStep]);

    const handleBack = () => {
        if (navigationLocked || navigationGuard?.() === false) return;
        if (type === 'onboarad') {
            if (inputRef.current && inputRef.current.handleBack) {
                inputRef.current.handleBack();
                return;
            }
            dispatch(updateActiveStep(activeStep - 1));
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
            return;
        }
        if ((type === 'createLead' && activeStep < 2) || (type === 'followup' && activeStep <= 1)) {
            dispatch(updateSteps(null));
        }
        if (type === 'followup' && activeStep < 2) {
            dispatch(updateBookingSteps(null));
        }
        dispatch(updateActiveStep(activeStep - 1));
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = async (status, button, e) => {
        if (navigationLocked || navigationGuard?.() === false) return;
        if (activeStep === 1 && button === 'Change Booking Status') {
            onOpenNextAction();
            anchorMoreMenuRef.current = e.currentTarget;
            return;
        }
        if (isAppointmentBooked === 'Unable to contact') {
            await inputRef.current?.submit?.(status);
            return;
        }
        if (status === 'Archive') {
            await inputRef.current.submit(status);
            return;
        }
        if (activeStep === (steps.length - 1)) {
            status = 'finish';
        }
        try {
            await inputRef.current.submit(status);
        }
        catch (err) {
            dispatch(updateError({ message: "Unable to proceed! Please check details", success: false }));
        }
    };

    const handleArchivePopup = () => {
        openArchivePopup();
        dispatch(updateFollowUpLead('archivedLead'));
    };

    const handleClose = () => {
        if (navigationLocked || navigationGuard?.() === false) return;
        setTimeout(() => {
            if (navigationGuard?.() === false) return;
            const htmlElement = document.querySelector('body');
            htmlElement.classList.remove('overflow-hidden');
            onClose();
            dispatch(updateActiveStep(0));
            setActiveStep(0);
            // Clear outcome-selection state so a 2nd lead doesn't skip step 0
            // or land on a stale step (Fix #3: stale BookingAttendance across leads)
            dispatch(updateBookingSteps(null));
            dispatch(contactLeadSlice(true));
            dispatch(setLoader(false));
            dispatch(startLoadingData(false));
            dispatch(updateCompleteStatus(false));
            setOutcome('Contact Lead');
            dispatch(setTodoListFilter(''));
            dispatch(leadFlowReminderData({ results: [], count: 0 }));
            if (typeof setOpenContactFromCall === 'function') {
                setOpenContactFromCall(false);
            }
            dispatch(setOpenCallScriptFromLeadPage(false));
            dispatch(updateLeadDataCount(false));
            // Clear the startTreatment/completeTreatment action flag this popup may
            // have set — left set, a LATER booking made elsewhere in the same
            // session (e.g. addAppointment() for an unrelated lead) would read this
            // stale flag and start/complete treatment again on the wrong booking.
            dispatch(setAction(null));
        }, 200);
    };

    const formatName = (u) => [u?.first_name || u?.firstName, u?.last_name || u?.lastName].filter(Boolean).join(' ').trim();
    const deriveLabel = (o) => {
        if (!o) return '';
        const nm = formatName(o);
        if (nm) return nm;
        const email = o?.lead_contact?.email || o?.email;
        if (email) return email;
        const phone = o?.lead_contact?.phone || o?.phoneNumber || o?.phone;
        if (phone) return formatUkPhone(phone);
        return '';
    };
    // Important: use only the caller-provided user to avoid stale flashes
    const getResolvedName = () => deriveLabel(user) || '';
    const getTitle = (value) => {
        switch (value) {
            case 'followup':
                {
                    const name = getResolvedName();
                    if (activeStep === 0) {
                        return name ? `Contact ${name}` : 'Contact';
                    }
                switch (isAppointmentBooked) {
                    case 'Booking Details':
                        return name ? `Booking for ${name}` : 'Booking Details';
                    case 'Unable to contact':
                        return name ? `No Answer — ${name}` : 'No Answer';
                    case 'Appointment Not Booked':
                        return name ? `Spoke - Not Booked — ${name}` : 'Spoke - Not Booked';
                    default:
                        return name ? `Contact ${name}` : 'Contact';
                }
                }
            default:
                return '';
        }
    };

    const getBtnTitle = () => {
        if (BookingAttendance === 'Unable to contact' || BookingAttendance === 'Appointment Not Booked') {
            if (archivedLead) return 'Archive';
            return 'Finish';
        }
        if (BookingAttendance === 'WhatsApp Follow Up') return 'Save & Close';
        if (BookingAttendance === 'WhatsApp Close') return 'Close & Resolve';
        return 'Continue';
    };

    const tabCounter = (value) => {
        if (value === 'to-do') {
            return taskFlowCounter?.[0]?.count || 0;
        }
        return 0;
    };

    const labelCount = (data) => {
        if (data.label === 'To-do') {
            return (
                <Box>
                    {data.label}
                    <Box sx={listCounterBoxStyle}>
                        {tabCounter(data.value)}
                    </Box>
                </Box>
            );
        }
        return data.label;
    };

    const buttonHandleClose = () => {
        onCloseNextAction();
        anchorMoreMenuRef.current = null;
    };

    const handleDepositPendingChange = (e) => {
        setDepositPaidStatus(e.target.checked);
        dispatch(setDepositStatus(e.target.checked));
        if (type === 'createLead') return;
        const treatment = currentTreatmentDataGlobal?.treatmentData?.treatment || tableRowLead && tableRowLead.treatment_name || '';
        const id = currentTreatmentDataGlobal?.treatmentData?.id || tableRowLead && tableRowLead.treatment_id || '';
        const data = {
            leadId: createLead?.id,
            treatmentId: id,
            payload: {
                treatment,
                is_treatment_fee_pending: !e.target.checked
            }
        };
        dispatch(setTreatmentLoading(true));
        dispatch(UpdateDepositPendingStatus(data, handleReloadLeads));
    };

    const handleCloseStartTreatment = () => onCloseStartTreatment(false);

    const handleStartTreatment = () => {
        // In-flight guard: isLoader already drives the StartTreatmentPopup "Yes"
        // button's disabled/loading state, but guard the handler itself too so a
        // stray extra invocation (e.g. a fast double keypress) can't dispatch a
        // second setAction/handleNext while the first request is still running.
        if (isLoader) return;
        dispatch(setAction('startTreatment'));
        handleNext('finish');
    };

    const handleCompleteTreatment = () => {
        if (isLoader) return;
        dispatch(setAction('completeTreatment'));
        handleNext('finish');
    };

    // Same rule as TreatmentMoreMenu.jsx's isStartTreatment: only offer "Move to
    // Started Treatment" while the current treatment is still in a status that
    // can transition into TREATMENT_STARTED. Without this the menu item stays
    // clickable against a stale snapshot after the treatment has already moved
    // on, producing the backend's 409 invalid_treatment_transition.
    const currentTreatmentStatus = treatmentState?.[0]?.status
        ?? currentTreatmentDataGlobal?.treatmentData?.status
        ?? tableRowLead?.status;
    const canStartTreatmentFromMenu = currentTreatmentStatus
        ? ['NEW', 'CONSULTATION_BOOKED', 'CONSULTATION_ATTENDED'].includes(currentTreatmentStatus)
        : true;

    const startTreatment = () => {
        onOpenStartTreatment(); onCloseNextAction();
        const id = currentTreatmentDataGlobal?.treatmentData?.id || tableRowLead && tableRowLead.treatment_id || '';
        let isTreatmentFeePending = true;
        if (isArray(tableRowLead?.treatmentData)) {
            isTreatmentFeePending = tableRowLead?.treatmentData?.find((ele) => ele.id === id)?.is_treatment_fee_pending;
        } else {
            isTreatmentFeePending = tableRowLead?.treatmentData?.lead_treatment?.is_treatment_fee_pending;
        }
        dispatch(setDepositStatus(isTreatmentFeePending || false));
        setDepositPaidStatus(!isTreatmentFeePending || false);
    };

    const completeTreatment = () => { setConfirmation(true); onCloseNextAction(); };

    const headerContactedCount = tableRowLead?.contacted_count ?? tableRowLead?.lead_treatments__lead_contacted_counts__count ?? 0;
    const headerJourneyIdx = getFollowUpIndex(headerContactedCount);

    const Body = (
        <>
            <AppBar sx={commonDialogHeaderStyle}>
                {embed && (
                    <Box>
                        <Button color='inherit' variant='outlined' sx={contactLeadCancelButtonStyle} disabled={navigationLocked} onClick={() => { if (!navigationLocked && navigationGuard?.() !== false) onBackEmbed?.(); }}>
                            Back
                        </Button>
                    </Box>
                )}
                    <Typography sx={contactLeadTitleStyle} variant='h5' component='div'>
                        {user && getTitle(type)} {type === 'followup' && <span> {user?.lead_treatments__lead_contacted_counts__count === 0 ? 'for the first time' : ''}</span>}
                    </Typography>
                    {type === 'followup' && (
                        <Box sx={{
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1.5,
                            '@keyframes headerPulse': {
                                '0%': { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(255,255,255,0.4)' },
                                '50%': { transform: 'scale(1.3)', boxShadow: '0 0 0 4px transparent' },
                                '100%': { transform: 'scale(1)', boxShadow: '0 0 0 0 transparent' },
                            }
                        }}>
                            {JOURNEY_STAGES.map((stage, i) => {
                                const isActive = i <= headerJourneyIdx;
                                const isCurrent = i === headerJourneyIdx;
                                return (
                                    <React.Fragment key={stage.value}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                            <Box sx={{
                                                width: isCurrent ? 24 : 20,
                                                height: isCurrent ? 24 : 20,
                                                borderRadius: '50%',
                                                bgcolor: isActive ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.25)',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                transition: 'all 0.2s ease', flexShrink: 0,
                                                ...(isCurrent && {
                                                    animation: 'headerPulse 2s ease-in-out infinite',
                                                }),
                                            }}>
                                                <Typography sx={{
                                                    fontSize: isCurrent ? '11px' : '10px',
                                                    fontWeight: 700,
                                                    color: isActive ? '#007867' : 'rgba(255,255,255,0.6)',
                                                    lineHeight: 1,
                                                }}>
                                                    {stage.step}
                                                </Typography>
                                            </Box>
                                            {isCurrent && (
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#fff', whiteSpace: 'nowrap' }}>
                                                    {stage.label}
                                                </Typography>
                                            )}
                                        </Box>
                                        {i < JOURNEY_STAGES.length - 1 && (
                                            <Box sx={{ width: 32, height: 2, borderRadius: '1px', bgcolor: i < headerJourneyIdx ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.2)' }} />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </Box>
                    )}
                    {(headerButtons || onboaradHeaderButtons) &&
                        <Box sx={{ ...cancelBoxStyle(onboaradHeaderButtons), display: 'flex', alignItems: 'center', gap: 1 }}>
                            {isMobilePopup && (
                                <IconButton
                                    onClick={() => setShowMobileInfo(!showMobileInfo)}
                                    sx={{
                                        width: 44, height: 44,
                                        color: showMobileInfo ? '#00A76F' : '#fff',
                                        bgcolor: showMobileInfo ? 'rgba(255,255,255,0.16)' : 'transparent',
                                    }}
                                >
                                    <Icon icon='mdi:information-outline' width={22} />
                                </IconButton>
                            )}
                            <Button color='inherit' variant='outlined' sx={contactLeadCancelButtonStyle} disabled={navigationLocked} onClick={() => handleClose('close')}>
                                Cancel
                            </Button>
                        </Box>
                    }
                </AppBar>
                {isMobilePopup && (
                    <Box sx={{ textAlign: 'center', py: 0.5, fontSize: '12px', color: '#637381', borderBottom: '1px solid rgba(145,158,171,0.12)' }}>
                        Contact Lead
                    </Box>
                )}
                <Stack sx={{ ...popupMainStackStyle(value), mb: 0 }} onClick={() => { dispatch(updateShowSubjectList(false)); }}>
                    <Box sx={leftBoxInnerStyle(expandLayout, activeStep)}>
                        {isMobilePopup && showMobileInfo ? (
                            <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                    <IconButton onClick={() => setShowMobileInfo(false)} sx={{ width: 44, height: 44 }}>
                                        <Icon icon='mdi:arrow-left' width={20} />
                                    </IconButton>
                                    <Typography variant='subtitle1' fontWeight={600}>Lead Info</Typography>
                                </Box>
                                <Typography color='text.secondary' sx={{ fontSize: '13px' }}>
                                    Lead information is available on the lead detail page. Tap &quot;Back&quot; to return to the contact form.
                                </Typography>
                            </Box>
                        ) : (
                        <>
                        {type === 'followup' && activeStep === 0 && <Box><SimilarLeadWarningPopup type={'DialogPopup'} dialogClose={() => handleClose('close')} /></Box>}
                        {steps[activeStep] && steps[activeStep].title ?
                            <Box sx={activeStepTitleStyle}>
                                <Typography variant='h5'>{steps[activeStep].title}</Typography>
                            </Box>
                            : ''}
                        {steps[activeStep] && steps[activeStep].bodyText ?
                            <Box sx={activeStepTextStyle}>
                                <Typography variant='body'>{steps[activeStep].bodyText}</Typography>
                            </Box>
                            : ''}
                        <Grid item xs={12} md={12} sx={{ ...cardMainAreaWrapper(activeStep, expandLayout) }} ariaLabel='popup-form-container' >
                            {recoveryContent}
                            {steps[activeStep] && RenderActiveStep({ component: steps[activeStep].component, inputRef })}
                        </Grid>
                        {steps[activeStep]?.hideFooter || (steps[activeStep]?.hideFooterOnSuccess) ? null : <Box
                            className='buttons-box'
                            sx={footerButtonBoxStyle}
                        >
                            <ButtonContainer
                                navigationLocked={navigationLocked}
                                ContactedCount={ContactedCount}
                                activeStep={activeStep}
                                activeTab={activeTab}
                                getBtnTitle={getBtnTitle}
                                handleArchivePopup={handleArchivePopup}
                                handleBack={handleBack}
                                handleNext={handleNext}
                                outcome={outcome}
                                steps={steps}
                                type={type}
                                bookingOnly={bookingOnly}
                                onMarkAsSpam={handleMarkAsSpam}
                                isDentallyBooking={isDentallyBooking}
                                disableNext={isDentallyBooking && steps[activeStep]?.label === 'Dentally Confirmation' && !dentallyPatientId} />
                        </Box>}
                        </>
                        )}
                    </Box>


                    <Box sx={rightBoxInnerStyle(expandLayout, value, activeStep)}>
                        <NormalLoading tableData={!treatmentData && 'No Found'} pageCount={!treatmentData && 'No Found'} />
                        {TABS.map((tab) => {
                            const isMatched = tab.value === value;
                            return isMatched && <Box key={tab.value} sx={tabContentBoxStyle}>{tab.component}</Box>;
                            // <Box >
                            //     {leadUserData?.treatment_data?.offers.length > 0 &&
                            //         <Card sx={offerMainBoxStyle} >
                            //             <Box sx={listHeaderBoxStyle}>
                            //                 <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>Offers</Typography>

                            //             </Box>

                            //             <Box sx={offerBoxStyle} >

                            //                 {leadUserData?.treatment_data?.offers?.map((data) => (
                            //                     <Box key={data?.id}>
                            //                         <Box sx={offerContentStyle}  >
                            //                             <Typography sx={{ fontSize: '15px', fontWeight: 700 }}>{capitalizeFirstLetter(data?.name)}</Typography>

                            //                             <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>{capitalizeFirstLetter(data?.offer)}</Typography>
                            //                             <Typography variant='body2' sx={timeLineTypoV2}>
                            //                                 {moment(data?.created_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ').format('DD MMM YYYY')} at {moment(data?.created_at, 'DD-MM-YYYY HH:mm:ss.SSSSSSZ').format('hh:mm a')}
                            //                             </Typography>

                            //                         </Box>

                            //                     </Box>

                            //                 ))}


                            //             </Box>
                            //         </Card>
                            //     }
                            //     <Box key={tab.value} sx={tabContentBoxStyle}>{tab.component}</Box>;
                            // </Box>

                        })}
                        <Box sx={tabsMainBoxStyle}>
                            <Tabs orientation='vertical' variant='fullWidth' value={value} onChange={handleChange} aria-label='icon label tabs example' sx={{ '.MuiTabs-flexContainer': { gap: 1 } }}>
                                {TABS.map((tab, index) => (
                                    <Tab icon={<Iconify icon={tab.icon} width={tab.width} height={tab.height} sx={{ mr: '0 !important', mb: '4px' }} />} key={index} label={labelCount(tab)} value={tab.value} sx={tabButtonStyle} />
                                ))}
                            </Tabs>
                        </Box>
                    </Box>
                    <Popper
                        sx={{ zIndex: 1399, marginLeft: '10px !important' }}
                        open={isOpenNextAction}
                        anchorEl={anchorMoreMenuRef.current}
                        transition
                        placement={isDesktop ? 'left-start' : 'right-end'}
                    >
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps} >
                                <Paper>
                                    <ClickAwayListener onClickAway={buttonHandleClose}>
                                        <MenuList id='split-button-menu' autoFocusItem sx={menuListStyle}>
                                            {canStartTreatmentFromMenu &&
                                                <MenuItem
                                                    key='Start Treatment'
                                                    onClick={startTreatment}
                                                    sx={menuItemStyle}
                                                >
                                                    Move to Started Treatment
                                                </MenuItem>
                                            }
                                            <MenuItem
                                                key='Complete Treatment'
                                                onClick={completeTreatment}
                                                sx={menuItemStyle}
                                            >
                                                Move to Completed Treatment
                                            </MenuItem>
                                            <MenuItem
                                                key='Mark as Spam'
                                                onClick={handleMarkAsSpam}
                                                sx={{ ...menuItemStyle, color: 'error.main' }}
                                            >
                                                Mark as Spam
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                    <StartTreatmentPopup
                        isOpen={isOpenStartTreatment}
                        handleCloseStartTreatment={handleCloseStartTreatment}
                        isPaymentMandatory={isPaymentMandatory}
                        depositStatus={depositPaidStatus}
                        handleDepositPendingChange={handleDepositPendingChange}
                        startTreatmentAPI={handleStartTreatment}
                    />
                    <CustomCompleteTreatmentDialog handleClose={() => setConfirmation(false)} handleYes={() => handleCompleteTreatment()} isLoader={isLoader} open={confirmation} />
                    <Dialog open={spamConfirmOpen} onClose={() => setSpamConfirmOpen(false)}>
                        <DialogTitle sx={{ color: 'error.main' }}>
                            Mark as Spam
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Only use this action if <strong>{user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : 'this lead'}</strong> did not
                                make the inquiry or is actual spam (e.g. a bot or fake submission).
                            </DialogContentText>
                            <DialogContentText sx={{ mt: 1 }}>
                                For any other reason (not interested, too expensive, changed mind, etc.), please go back
                                and select the appropriate archive reason instead.
                            </DialogContentText>
                            <DialogContentText sx={{ mt: 1, fontWeight: 600 }}>
                                This lead will be removed from all counts and reports.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setSpamConfirmOpen(false)} color='inherit'>
                                Cancel
                            </Button>
                            <Button onClick={handleMarkAsSpamConfirm} variant='contained' color='error'>
                                Confirm Mark as Spam
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
        </>
    );

    if (embed) {
        return (
            <Box sx={{ width: '100%', bgcolor: '#F4F6F8' }}>
                {Body}
            </Box>
        );
    }

    return (
        <>
            <Dialog
                fullScreen
                TransitionComponent={Transition}
                open={open}
                onClose={handleClose}
                id='component-drawer'
                sx={contactLeadDialogStyle(type)}>
                {/* eslint-disable-next-line no-nested-ternary */}
                {followLeadNotFound && !followLead ? (
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            gap: 2,
                            px: 3,
                        }}
                    >
                        <Typography variant="h5" color="text.secondary" textAlign="center">
                            This patient is no longer available
                        </Typography>
                        <Typography variant="body2" color="text.disabled" textAlign="center">
                            The patient may have been archived or marked as spam.
                        </Typography>
                        <Button variant="outlined" onClick={handleClose} sx={{ mt: 1 }}>
                            Close
                        </Button>
                    </Box>
                ) : !followLead ? (
                    <NormalLoading />
                ) : (
                    Body
                )}
            </Dialog >
            {!hideDebug && <ContactPopupDebugBox
                popup="OpenContactLeadPopup (V1)"
                debugSource={debugSource}
                practiceId={practiceId}
                leadId={user?.lead_id || user?.id}
                taskId={user?.task_id || null}
                isFollowUpV2={false}
                initialStep={{
                    type,
                    stepCount: Array.isArray(steps) ? steps.length : 0,
                    stepTitles: Array.isArray(steps) ? steps.map((s) => s?.title || s?.label || null) : [],
                    bookingOnly,
                    defaultTab,
                }}
                activeOutcome={{
                    activeStep,
                    activeStepTitle: steps?.[activeStep]?.title || steps?.[activeStep]?.label || null,
                    outcome,
                    rightPanelTab: value,
                }}
            />}
        </>
    );
};

export default OpenContactLeadPopup;

OpenContactLeadPopup.propTypes = {
    open: PropTypes.bool,
    openArchivePopup: PropTypes.func,
    onClose: PropTypes.func,
    steps: PropTypes.array,
    type: PropTypes.string,
    inputRef: PropTypes.any,
    user: PropTypes.object,
    BookingAttendance: PropTypes.any,
    updateStep: PropTypes.func,
    validStep: PropTypes.bool,
    headerButtons: PropTypes.bool,
    onboaradHeaderButtons: PropTypes.bool,
    setActive: PropTypes.func,
    ContactedCount: PropTypes.any,
    handleReloadLeads: PropTypes.any,
    setOpenContactFromCall: PropTypes.func,
    embed: PropTypes.bool,
    onBackEmbed: PropTypes.func,
    navigationLocked: PropTypes.bool,
    navigationGuard: PropTypes.func,
    recoveryContent: PropTypes.node,
    defaultTab: PropTypes.string,
    bookingOnly: PropTypes.bool,
    source: PropTypes.string,
    threadId: PropTypes.any,
    onWhatsAppClose: PropTypes.func,
    debugSource: PropTypes.string,
    // Hide the superadmin debug bar (the call flow's follow-up step).
    hideDebug: PropTypes.bool,
    practiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
